<div [innerHTML]="filteredHtml"></div>